import { placeholderImage } from '@grandvisionhq/utils';

const createImageUrl = (imagePath, options)=>{
    const imageQueryParams = (options === null || options === void 0 ? void 0 : options.imageQueryParams) || '';
    const validImagePath = imagePath === null || imagePath === void 0 ? void 0 : imagePath.startsWith('http');
    if (validImagePath) {
        return `${imagePath}${imageQueryParams}`;
    }
    return `${placeholderImage.url}${imageQueryParams}`;
};

export { createImageUrl };
//# sourceMappingURL=create-image-url.js.map
